import type { SupabaseClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.NEXT_PUBLIC_SUPABASE_URL;
const SUPABASE_PUBLIC_KEY =
  process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY || process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

let clientPromise: Promise<SupabaseClient | null> | undefined;
let publicClientPromise: Promise<SupabaseClient | null> | undefined;

export function isSupabaseConfigured(): boolean {
  return Boolean(SUPABASE_URL && (SUPABASE_PUBLIC_KEY || process.env.SUPABASE_SERVICE_ROLE_KEY));
}

export function getPublicSupabaseClient(): Promise<SupabaseClient | null> {
  if (!publicClientPromise) {
    publicClientPromise = createPublicClient();
  }
  return publicClientPromise;
}

async function createPublicClient(): Promise<SupabaseClient | null> {
  if (!SUPABASE_URL || !SUPABASE_PUBLIC_KEY) {
    return null;
  }

  const { createClient } = await import('@supabase/supabase-js');
  return createClient(SUPABASE_URL, SUPABASE_PUBLIC_KEY, { auth: { persistSession: false } });
}

export function getSupabaseClient(): Promise<SupabaseClient | null> {
  if (!clientPromise) {
    clientPromise = createSupabaseClient();
  }
  return clientPromise;
}

async function createSupabaseClient(): Promise<SupabaseClient | null> {
  const url = SUPABASE_URL;
  const key = process.env.SUPABASE_SERVICE_ROLE_KEY || SUPABASE_PUBLIC_KEY;

  if (!url || !key) {
    return null;
  }

  const { createClient } = await import('@supabase/supabase-js');
  return createClient(url, key, { auth: { persistSession: false } });
}
